// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZfPY","footer":"styles_footer__1LqRJ"};